import { render, staticRenderFns } from "./SWER2.vue?vue&type=template&id=6535b76a"
import script from "./SWER2.vue?vue&type=script&lang=js"
export * from "./SWER2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports